<template>
  <div
    v-if="hasAnyReasonToShow"
    class="padding-2xl"
    style="background-color: var(--white)"
  >
    <div
      :class="['message with-icon with-close roomy margin-bottom-0', { warning: $dt.indication === 'warning' }, { danger: $dt.indication === 'danger' }]"
      :style="`background-color: ${theme.backgroundcolor}; --hr-border-color: ${theme.bordercolor};`"
    >
      <div
        v-if="$dt.indication === 'warning'"
        class="laptop:display-flex align-between"
      >
        <font-awesome-icon
          :icon="$v7.duotone.faMegaphone"
          class="decorative fa-shake"
          style="--fa-secondary-opacity: 0.6; --fa-animation-delay: 0.5s; --fa-animation-iteration-count: 3"
          size="3x"
        />
        <div>
          <h1 class="h4">
            <span v-if="firstName">{{ firstName }}, y</span>
            <span v-else>Y</span>our subscription is expiring soon
          </h1>
          <p class="margin-top-2xs margin-bottom-sm laptop:margin-bottom-0">
            Be sure to
            <site-link :to="{ name: 'account.billing' }">renew it in your Account</site-link>
            to keep access to Pro services, new icons, and support!
          </p>
        </div>

        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="hideSweatband"
        >
          <font-awesome-icon
            :icon="$v7.duotone.faCircleXmark"
            style="--fa-width: auto"
          />
        </button>
      </div>

      <div
        v-if="$dt.indication === 'danger'"
        class="laptop:display-flex align-between"
      >
        <font-awesome-icon
          :icon="$v7.duotone.faMegaphone"
          class="decorative fa-shake"
          style="--fa-secondary-opacity: 0.6; --fa-animation-delay: 0.5s; --fa-animation-iteration-count: 3"
          size="3x"
        />
        <div>
          <h1 class="h4">
            <span v-if="firstName">{{ firstName }}, t</span>
            <span v-else>T</span>here was an error when processing your payment
          </h1>
          <p class="margin-top-2xs margin-bottom-sm laptop:margin-bottom-0">We won't be able to renew your subscription until you resolve it.</p>
        </div>
        <div>
          <wa-action-button
            v-if="$dt.isStripe"
            class="button compact red"
            label="Update Payment via Stripe"
            @click.prevent="manageBilling"
          />

          <a
            v-if="$dt.isBraintree"
            class="button compact margin-bottom-0"
            href="http://paypal.com"
            target="_blank"
          >
            Update Payment via PayPal
            <font-awesome-icon
              :icon="$v7.solid.faArrowRight"
              class="margin-left-xs"
              size="lg"
            />
          </a>
        </div>
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="hideSweatband"
        >
          <font-awesome-icon
            :icon="$v7.duotone.faCircleXmark"
            style="--fa-width: auto"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { BillingPortal } from 'app/views/accounts/mixins'
  import moment from 'moment'
  import get from 'lodash/get'

  const SHOW_AFTER = 7 // days

  export default {
    name: 'SubscriptionNotices',

    mixins: [BillingPortal],

    data() {
      return {
        showAfter: null
      }
    },

    computed: {
      firstName() {
        return get(this, ['$profile', 'firstName'], '')
      },

      alertKey() {
        return `showAfter:${this.$dt.indication}`
      },

      hasAnyReasonToShow() {
        const { indication } = this.$dt
        const isNotHidden = moment().isSameOrAfter(this.showAfter)

        return isNotHidden && (indication === 'warning' || indication === 'danger')
      },

      theme() {
        const { indication } = this.$dt

        if (indication === 'warning') {
          return {
            backgroundcolor: 'var(--yellow1)',
            bordercolor: 'var(--fa-dk-yellow)'
          }
        } else if (indication === 'danger') {
          return {
            backgroundcolor: 'var(--red1)',
            bordercolor: 'var(--fa-dk-red)'
          }
        } else {
          return {
            backgroundcolor: 'var(--fa-lt-gravy)',
            bordercolor: 'var(--fa-gravy)'
          }
        }
      }
    },

    async mounted() {
      this.showAfter = await this.$getItem(this.alertKey)

      if (!this.showAfter) {
        this.showAfter = moment().valueOf()

        await this.$setItem(this.alertKey, this.showAfter)
      }
    },

    methods: {
      async hideSweatband() {
        this.showAfter = moment().add(SHOW_AFTER, 'days').startOf('day').valueOf()

        this.$setItem(this.alertKey, this.showAfter)
      }
    }
  }
</script>
